export default function DeliveryInfo() {
    // Calculate delivery date (3 days from today)
    const now = new Date();
    const delivery = new Date();
    delivery.setDate(now.getDate() + 3);
  
    const weekday = delivery.toLocaleDateString('en-US', { weekday: 'long' });
    const day = delivery.getDate();
    const month = delivery.toLocaleDateString('en-US', { month: 'long' });
  
    const deliveryDate = `${weekday}, ${day} ${month}`;
  
    return (
      <div className="text-sm text-green-700 font-medium mt-2">
        FREE delivery <span className="font-bold">{deliveryDate}</span>. Order within <span className="font-bold">5 hrs 45 mins</span>.
      </div>
    );
  }
  